/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback, useEffect } from "react";
import "../../css/integration.css";
import callApi from "../../utils/apiCaller";
import Swal from "sweetalert2";
import uuid from "uuid-random";
import {
	DeleteMajor,
	DomainNewMajor,
	DuplicateMinor,
	ExchangeMajor,
	ExistingInventoryMajor,
	FlagMajor,
} from "@shopify/polaris-icons";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
	Button,
	Card,
	Banner,
	Icon,
	Modal,
	Badge,
	Link,
	TextContainer,
	TextField,
	Checkbox,
	Heading,
	Toast,
	Frame,
} from "@shopify/polaris";
import { Row, Table, Col } from "reactstrap";
import config from "../../config/config";
import {
	actFetchDataSettings,
	actFetchListStore,
	actFetchShowLoadingPage,
} from "../../actions/index";

import { useDispatch, useSelector } from "react-redux";
import BuyMultiStores from "./BuyMultiStores";

const MultiStore = () => {
	const dispatch = useDispatch();
	const [modalActive, setModalActive] = useState(false);
	const [modalAddStore, setModalAddStore] = useState(false);
	const [copied, setCopied] = useState(false);
	const [checkedInherit, setCheckedInherit] = useState(false);
	const [connectionKey, setConnectionKey] = useState("");
	const [storeName, setStoreName] = useState("");
	const [storeNameErr, setStoreNameErr] = useState("");
	const [connectionKeyErr, setConnectionKeyErr] = useState("");
	const [mainStore, setMainStore] = useState("");
	const listStore = useSelector((state) => state.listStore);
	const dataSettings = useSelector((state) => state.dataSettings);

	useEffect(() => {
		getListStoreIntegrate();
	}, []);

	useEffect(() => {
		if (config.checkLocalStorage) {
			if (localStorage.getItem("shop-process-multi") === config.shop) {
				setModalActive(true);
			}
		}
	}, []);

	const getListStoreIntegrate = () => {
		let params = {
			action: "getListStoreIntegrate",
		};
		callApi("get", params).then(async (res) => {
			if (res.data.state === 1) {
				dispatch(actFetchListStore(res.data.listStore));
				setMainStore(res.data.listStore[0].shop);
			}
		});
	};

	const handleChange = useCallback(
		(newChecked) => setCheckedInherit(newChecked),
		[]
	);

	const confirmDisconnectStore = (store, index) => {
		Swal.fire({
			icon: "warning",
			title: "Are you sure?",
			showCancelButton: true,
			showConfirmButton: true,
		}).then((result) => {
			if (result.value) {
				disconnectStore(store, index);
			}
		});
	};

	const disconnectStore = (store, index) => {
		let params = {
			action: "disconnectStore",
			store: store,
		};
		callApi("get", params).then(async (res) => {
			if (res.data.state === 1) {
				let newListStore = [...listStore];
				newListStore.splice(index, 1);
				dispatch(actFetchListStore(newListStore));
				Swal.fire({
					icon: "success",
					title: "Successfully",
					text: "Store: " + store + " has been disconnected!",
					showCloseButton: false,
					showConfirmButton: false,
					timer: 3000,
				});
			}
		});
	};

	const addStoreIntegration = () => {
		if (storeName === "") {
			setConnectionKeyErr("Store name is required");
		} else {
			let params = {
				action: "addStoreIntegration",
				store: storeName,
			};
			callApi("get", params).then(async (res) => {
				if (res.data.state === 1) {
					setModalAddStore(false);
					if (config.checkLocalStorage) {
						localStorage.setItem("shop-process-multi", storeName);
					}
					window.open(res.data.url, "_blank", "noopener,noreferrer");
				} else {
					Swal.fire({
						icon: "warning",
						html: res.data.msg,
						showConfirmButton: true,
					});
				}
			});
		}
	};

	const submitConnectionKey = () => {
		if (config.checkLocalStorage) {
			localStorage.removeItem("shop-process-multi");
		}
		if (connectionKeyErr === "") {
			if (connectionKey === "") {
				setConnectionKeyErr("Connection key is required");
			} else {
				let params = {
					action: "submitConnectionKey",
					connectionKey: connectionKey,
					checkedInherit: checkedInherit,
					count: listStore.length,
				};
				dispatch(actFetchShowLoadingPage(true));
				callApi("get", params).then(async (res) => {
					if (res.data.state === 1) {
						dispatch(actFetchShowLoadingPage(false));
						Swal.fire({
							icon: "success",
							title: "Successfully",
							html:
								"Store: <b>" +
								config.shop +
								"</b> has been integrated!",
							showConfirmButton: true,
							showCloseButton: true,
							allowOutsideClick: false,
						}).then((result) => {
							if (result.isConfirmed) {
								window.location.reload();
							}
						});
					} else {
						dispatch(actFetchShowLoadingPage(false));
						Swal.fire({
							icon: "warning",
							html: res.data.msg,
							showConfirmButton: true,
						});
					}
				});
			}
		}
	};

	const openModalConnection = () => {
		setModalActive(true);
	};

	const closeModalAddConnection = () => {
		if (config.checkLocalStorage) {
			localStorage.removeItem("shop-process-multi");
		}
		setModalActive(false);
	};

	const getStatus = (shopParent, shop) => {
		if (shopParent === shop) {
			return <Badge status="success"> Main store</Badge>;
		} else {
			return <Badge status="info"> Integrated store</Badge>;
		}
	};

	const generateConnectionKey = () => {
		if (dataSettings.plan === "free" || dataSettings.plan === "basic") {
			Swal.fire({
				icon: "warning",
				title: "Notice!",
				html: "The multi-store integration feature is only for customers using the <b>Pro plan or higher</b>, please <b>upgrade</b> to use this feature!",
				confirmButtonColor: "#6371c7",
				showCloseButton: true,
				showConfirmButton: true,
				confirmButtonText: "OK",
			});
		} else {
			let connectionKey = uuid();
			let params = {
				action: "generateConnectionKey",
				connectionKey,
			};
			dispatch(actFetchShowLoadingPage(true));
			callApi("get", params).then(async (res) => {
				if (res.data.state === 1) {
					let newDataSettings = { ...dataSettings };
					newDataSettings.connection_key = connectionKey;
					dispatch(actFetchShowLoadingPage(false));
					dispatch(actFetchDataSettings(newDataSettings));
				}
			});
		}
	};

	const deleteConnectionKey = () => {
		let params = {
			action: "deleteConnectionKey",
		};
		dispatch(actFetchShowLoadingPage(true));
		callApi("get", params).then(async (res) => {
			if (res.data.state === 1) {
				let newDataSettings = { ...dataSettings };
				newDataSettings.connection_key = null;
				dispatch(actFetchShowLoadingPage(false));
				dispatch(actFetchDataSettings(newDataSettings));
			}
		});
	};

	const changeconnectionKey = useCallback((value) => {
		setConnectionKey(value);
		if (value === "") {
			setConnectionKeyErr("Connection key is required");
		} else {
			const regEx = new RegExp("^[a-zA-Z0-9_.#.-]*$");
			if (!regEx.test(value)) {
				setConnectionKeyErr("The connection key is invalid");
			} else {
				setConnectionKeyErr("");
			}
		}
	}, []);

	const changeStore = useCallback((value) => {
		setStoreName(value);
		if (value === "") {
			setStoreNameErr("Store name is required");
		} else {
			setStoreNameErr("");
		}
	}, []);

	const toastMarkup = copied ? (
		<Toast
			content={"Copied"}
			onDismiss={() => setCopied(false)}
			duration={3000}
		/>
	) : null;
	return (
		<div style={{ marginTop: "20px" }} className="integration-page">
			{/* {listStore.length > 1 ? ( */}
			<Card sectioned title="Multi Stores Integration">
				<Row
					// style={{ textAlign: 'end' }}
					className="mb-2"
				>
					<Col>
						<a
							href="https://docs.synctrack.io/feature-guides/how-to-set-up-and-what-you-should-know-about-multi-store-feature#how-to-set-up-multi-store-connection"
							target="_blank"
						>
							View multi-store instruction
						</a>
					</Col>
				</Row>
				<div className="pl-5 pr-5">
					{dataSettings.connection_key === null &&
					listStore.length < 2 ? (
						<Row>
							<Col md={6}>
								<div className="integration-page-layout text-center">
									<div
										className="statistical-layout-icon"
										style={{
											backgroundColor: "#aee9d1",
											margin: "auto",
											borderRadius: "50%",
										}}
									>
										<Icon
											color="white"
											source={DomainNewMajor}
										/>
									</div>
									<div className="p-2">
										<TextContainer>
											<Heading>New Setup</Heading>
											<p>
												This is the first store where
												you've installed the app. You
												don't have a connection key.
												Generate one so you can use it
												to connect more stores.
											</p>
										</TextContainer>
									</div>
									<div className="p-3">
										<Button
											onClick={generateConnectionKey}
											primary
										>
											Generate a connection key
										</Button>
									</div>
								</div>
							</Col>
							<Col md={6}>
								<div className="integration-page-layout text-center">
									<div
										className="statistical-layout-icon"
										style={{
											backgroundColor: "#aee9d1",
											margin: "auto",
											borderRadius: "50%",
										}}
									>
										<Icon
											color="white"
											source={ExistingInventoryMajor}
										/>
									</div>
									<div className="p-2">
										<TextContainer>
											<Heading>Existing Setup</Heading>
											<p>
												This is not the first store
												where you've installed the app.
												You have a connection key. Add a
												key to this store so it will be
												connected to your existing
												setup.
											</p>
										</TextContainer>
									</div>
									<div className="p-3">
										<Button
											onClick={() =>
												openModalConnection()
											}
											primary
										>
											Add a existing key
										</Button>
									</div>
								</div>
							</Col>
						</Row>
					) : (
						<div>
							<Row>
								<div className="text-right w-100 mb-2">
									<Button
										onClick={() => setModalAddStore(true)}
										primary
									>
										Add Connection
									</Button>
								</div>
							</Row>
							{dataSettings.plan === "unlimited" ? (
								<Row>
									<div>
										Total slots:{" "}
										<b>{dataSettings.slot_multi_stores}</b>{" "}
										| Used: <b>{listStore.length}</b>
									</div>
								</Row>
							) : null}
							<Row className="multi-store-table mt-2">
								<Table responsive bordered>
									<thead>
										<tr>
											<th>#</th>
											<th>Store</th>
											<th className="text-center">
												Status
											</th>
											<th className="text-center">
												Connected at
											</th>
											<th className="text-center"></th>
										</tr>
									</thead>
									<tbody>
										{listStore.map((value, index) => {
											return (
												<tr key={index}>
													<th scope="row">
														{index + 1}
													</th>
													<td
														className={
															value.shop ===
															config.shop
																? "active"
																: ""
														}
													>
														<Link
															url={
																"https://" +
																value.shop
															}
															external
														>
															{value.shop}
														</Link>
													</td>
													<td className="text-center">
														{getStatus(
															value.shop_parent,
															value.shop
														)}
													</td>
													<td className="text-center">
														{value.connected_at !==
														null
															? moment(
																	value.connected_at
															  ).format(
																	"D MMM YYYY, hh:mm a"
															  )
															: "---"}
													</td>
													<td className="text-center">
														{value.shop_parent !==
															value.shop &&
														config.shop ===
															mainStore ? (
															<Button
																onClick={() =>
																	confirmDisconnectStore(
																		value.shop,
																		index
																	)
																}
															>
																Disconnect store
															</Button>
														) : null}
														{config.shop ===
														value.shop ? (
															<Badge status="success">
																This store
															</Badge>
														) : null}
													</td>
												</tr>
											);
										})}
									</tbody>
								</Table>
							</Row>
							{dataSettings.connection_key !== null ? (
								<Row className="connection-key-layout mt-4">
									<Heading>Connection key:</Heading>{" "}
									<span className="key">
										{dataSettings.connection_key}
									</span>
									<CopyToClipboard
										text={dataSettings.connection_key}
										onCopy={() => setCopied(true)}
									>
										<span className="ml-3">
											<Button icon={DuplicateMinor}>
												Copy
											</Button>
										</span>
									</CopyToClipboard>
									<span className="ml-3">
										<Button
											onClick={() =>
												generateConnectionKey()
											}
											icon={ExchangeMajor}
										>
											Change
										</Button>
									</span>
									<span className="ml-3">
										<Button
											onClick={() =>
												deleteConnectionKey()
											}
											icon={DeleteMajor}
										>
											Delete
										</Button>
									</span>
								</Row>
							) : (
								<Row className="connection-key-layout mt-4">
									{config.shop === mainStore ? (
										<Button
											onClick={generateConnectionKey}
											primary
										>
											Generate a connection key
										</Button>
									) : null}
								</Row>
							)}
						</div>
					)}
					<Row className="mt-5">
						<Col md={12} className="mb-3">
							<Banner
								icon={FlagMajor}
								status="success"
								title="Benefits of integration when you have multiple stores?"
							>
								<p
									className="mt-2 mb-3"
									style={{ lineHeight: "26px" }}
								>
									- Manage tracking number synchronization
									across all stores in one place.
									<br />- Pay a single fee for syncing
									tracking numbers across multiple stores.
								</p>
								<a
									href="https://www.youtube.com/watch?v=pokFbQ3YvHc"
									target="_blank"
								>
									How to connect multiple stores?
								</a>
							</Banner>
						</Col>
					</Row>
				</div>
			</Card>
			{dataSettings.plan == "unlimited" &&
			config.platform != "WOO_COMMERCE" ? (
				<BuyMultiStores />
			) : null}
			<Modal
				open={modalActive}
				onClose={() => closeModalAddConnection()}
				title="Add Connection Confirm"
				primaryAction={{
					disabled: connectionKeyErr === "" ? false : true,
					content: "Submit",
					onAction: () => submitConnectionKey(),
				}}
				secondaryActions={[
					{
						content: "Cancel",
						onAction: () => closeModalAddConnection(),
					},
				]}
			>
				<Modal.Section>
					<TextContainer>
						<TextField
							label="Connection Key: "
							value={connectionKey}
							onChange={changeconnectionKey}
							error={connectionKeyErr}
							helpText="Example: xxxx-xxxx-xxxx-xxxx-xxxx"
						/>
						<Checkbox
							label="Inherit the PayPal account from the main store"
							checked={checkedInherit}
							onChange={handleChange}
						/>
						<div>
							<Banner status="warning">
								<p>
									When you connect stores, order information
									is also shared among the connected stores
								</p>
							</Banner>
						</div>
					</TextContainer>
				</Modal.Section>
			</Modal>
			<Modal
				open={modalAddStore}
				onClose={() => setModalAddStore(false)}
				title="Add Connection"
				primaryAction={{
					content: "Add Store",
					onAction: () => addStoreIntegration(),
				}}
				secondaryActions={[
					{
						content: "Cancel",
						onAction: () => setModalAddStore(false),
					},
				]}
			>
				<Modal.Section>
					<TextContainer>
						<TextField
							label="Store name: "
							value={storeName}
							onChange={changeStore}
							error={storeNameErr}
							helpText="Example: mystore.myshopify.com"
						/>
						<div>
							<Banner status="warning">
								<p>
									When you connect stores, order information
									is also shared among the connected stores
								</p>
							</Banner>
						</div>
					</TextContainer>
				</Modal.Section>
			</Modal>
			{toastMarkup}
		</div>
	);
};

export default MultiStore;
